"use strict";import{tag as a}from"../custom-tag.js";export function colorRoundedIcon({height:t=16,width:l=16,hidden:e=!1,title:r="Color rounded"}={}){return a`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${l}
      height=${t}
      fill="transparent"
      viewBox="0 0 24 24"
      aria-hidden="${e?"true":"false"}"
      role="img"
      aria-label="${r}"
    >
      <g opacity=".8">
        <path fill="#66D7F3" d="M0 10C0 4.477 4.477 0 10 0h14v24H0z" />
        <path
          fill="#0076D5"
          d="M5 12.917A7.917 7.917 0 0 1 12.917 5H24v19H5z"
        />
        <path
          fill="#0051AF"
          d="M11 16.417A5.417 5.417 0 0 1 16.417 11H24v13H11z"
        />
      </g>
    </svg>
  `}
//# sourceMappingURL=colorRounded.js.map
